import SemanticClasses from '../../typings/semantic/semanticClasses';
import VocabularyCollapse from './vocabularyCollapse';
import { styled } from '@mui/material/styles';

const ColoredVocabularyCollapse = styled(VocabularyCollapse)(props => ({
	[`& .${SemanticClasses.semanticTopic}`]: {
		backgroundColor: props.palette.highlight
	},
	[`& .${SemanticClasses.semanticTopic}:hover`]: {
		backgroundColor: props.palette.hover
	},
	[`& .${SemanticClasses.semanticTopic}.${SemanticClasses.semanticTopicSelected}`]: {
		backgroundColor: props.palette.selectedBar
	},
	[`& .${SemanticClasses.vocabularyRectangle}`]: {
		backgroundColor: props.palette.selectedBar
	}
}));

export default ColoredVocabularyCollapse;
